import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import isNil from 'lodash/isNil';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { myProfile } from 'Redux/user-profile/selectors';
import { withCapacitor } from 'Util/Capacitors/hoc';
import { useMyCourseData } from 'Domain/MyCourseData';
import { useGetFeedbackTemplate, useGiveFeedback } from 'Util/FeedBackService';
import { FeedbackImprovementAndSatisfiedModal, OPTIONS_STATE } from 'Components/Feedback';

import { REPORT_STATE } from './constant';

function getFormOptions(options) {
  if (!options) {
    return [];
  }
  return options.map((option) => ({ label: option.title, value: option.value }));
}

function getFormRating(min = 0, max = 10) {
  const ratings = [];
  for (let i = min; i <= max; i++) {
    ratings.push(i);
  }
  return ratings;
}

const FeedbackImprovementAndSatisfied = ({
  capacitorContext: { deviceInfo },
  user,
  contentType,
  isShow,
  handleSubmitFeedback,
  handleCancelFeedback,
}) => {
  const { data: templateData, loading: isTemplateLoading } = useGetFeedbackTemplate({
    templateId: 'IMPROVEMENT_SATISFIED_FEEDBACK',
  });

  const { courseCode, loading: myCourseLoading } = useMyCourseData();

  const [reportState, setReportState] = useState(REPORT_STATE.INITIALIZED);

  const { giveFeedback, loading: isGiveFeedbackLoading } = useGiveFeedback({
    templateId: 'IMPROVEMENT_SATISFIED_FEEDBACK',
    onCompleted: () => {
      setReportState(REPORT_STATE.COMPLETED);
    },
  });

  const { t } = useTranslation('feedback');

  const templateComponents = templateData?.getTemplate?.components ?? [];
  const inputComponents = templateComponents.reduce(
    (obj, item) => Object.assign(obj, { [item.name]: item }),
    {}
  );

  const handleCloseModal = () => {
    if (reportState === REPORT_STATE.COMPLETED) {
      handleSubmitFeedback();
    } else {
      handleCancelFeedback();
    }
  };

  return (
    <FeedbackImprovementAndSatisfiedModal
      onCloseModal={handleCloseModal}
      formId="feedback-improvement-and-satisfied-platform-form"
      isOpen={isShow && !isTemplateLoading}
      loading={isGiveFeedbackLoading}
      title={t('IMPROVEMENT_AND_SATISFIED.PLATFORM.TITLE')}
      ratings={getFormRating(
        inputComponents['rating']?.minValue,
        inputComponents['rating']?.maxValue
      )}
      satisfiedLabel={t('IMPROVEMENT_AND_SATISFIED.PLATFORM.OPTION_SATISFIED_LABEL')}
      satisfiedOptions={getFormOptions(inputComponents['satisfiedCategory']?.options)}
      improvementLabel={t('IMPROVEMENT_AND_SATISFIED.PLATFORM.OPTION_IMPROVEMENT_LABEL')}
      improvementOptions={getFormOptions(inputComponents['improvementCategory']?.options)}
      getOptionState={(rating) => {
        return isNil(rating)
          ? OPTIONS_STATE.DISABLED
          : rating > 8
          ? OPTIONS_STATE.SATISFIED
          : OPTIONS_STATE.IMPROVEMENT;
      }}
      isSuccess={reportState === REPORT_STATE.COMPLETED}
      onSubmit={(formValue) => {
        giveFeedback(
          courseCode,
          user.id,
          { firstname: user.firstname, lastname: user.lastname, ...deviceInfo },
          contentType,
          {
            feedback: formValue.feedback ?? '',
            rating: formValue.rating,
            satisfiedCategory: formValue.satisfiedCategory ?? [],
            improvementCategory: formValue.improvementCategory ?? [],
          }
        );
      }}
    />
  );
};

FeedbackImprovementAndSatisfied.propTypes = {
  isShow: PropTypes.bool,
  contentType: PropTypes.string,
  handleSubmitFeedback: PropTypes.func,
  handleCancelFeedback: PropTypes.func,
};

FeedbackImprovementAndSatisfied.defaultProps = {
  contentType: 'NPS',
  handleSubmitFeedback: () => {},
  handleCancelFeedback: () => {},
};

const FeedbackImprovementAndSatisfied1 = compose(
  withCapacitor,
  connect((state) => {
    const user = myProfile(state);
    return { user };
  }, {})
)(FeedbackImprovementAndSatisfied);

export default FeedbackImprovementAndSatisfied1;
